import { sessionStorageController } from '../../services/storages';
import type { BulletinBoard } from '@autopass-web/types';

export function filterAndSortPromotions(promotions: BulletinBoard[]) {
  return promotions
    .filter((board) => {
      const { parkinglot_ids } = board.attributes;
      if (parkinglot_ids) {
        const parkinglotList = parkinglot_ids.split(',').map((id) => id.trim());
        const parkinglotId = sessionStorageController.getParkinglot()?.id;
        const isCurrentParkinglot = parkinglotList.indexOf(parkinglotId) !== -1;

        return isCurrentParkinglot;
      }
      return true;
    })
    .sort((a, b) => a.sort - b.sort);
}
